import { jsPDF } from 'jspdf';

/**
 * Generates a professional PDF resume on-demand based on intern data.
 * Does not store any files, everything is client-side.
 */
export const generateResumePDF = (data) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Colors
  const primaryColor = [15, 93, 154]; // #0f5d9a
  const secondaryColor = [30, 58, 138]; // #1e3a8a
  const textColor = [33, 33, 33];
  const lightTextColor = [102, 102, 102];

  // --- Header ---
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, pageWidth, 40, 'F');
  
  // Add Logo to Header
  try {
    // Note: In a production environment, you'd typically pre-load this or use a base64 string
    // Here we use the public URL. jsPDF handles some synchronous loading for simple cases
    doc.addImage('/branding/logo-hero.png', 'PNG', 150, 10, 45, 12);
  } catch (e) {
    console.error('Logo failed to load for PDF:', e);
  }

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text(data.name.toUpperCase(), 20, 25);
  
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text(data.role, 20, 32);

  // --- Contact Info ---
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text(`Email: ${data.email}`, pageWidth - 20, 25, { align: 'right' });
  doc.text(`Reg No: ${data.studentDetails?.registrationNumber || 'N/A'}`, pageWidth - 20, 32, { align: 'right' });
  doc.text(`College: ${data.studentDetails?.college || 'N/A'}`, pageWidth - 20, 38, { align: 'right' });

  // --- Summary ---
  doc.setTextColor(...primaryColor);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('PROFESSIONAL SUMMARY', 20, 55);
  doc.setDrawColor(...primaryColor);
  doc.line(20, 57, 60, 57);

  doc.setTextColor(...textColor);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  const summary = `Professional ${data.role} with hands-on experience at Hara XY Innovation Lab. Demonstrated expertise in ${data.skills.slice(0, 3).join(', ')} and other advanced technologies. Committed to delivering high-quality results and professional excellence.`;
  const splitSummary = doc.splitTextToSize(summary, pageWidth - 40);
  doc.text(splitSummary, 20, 65);

  // --- Skills ---
  doc.setTextColor(...primaryColor);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('TECHNICAL SKILLS', 20, 95);
  doc.line(20, 97, 60, 97);

  doc.setTextColor(...textColor);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  
  let yPos = 105;
  data.skills.forEach((skill, index) => {
    doc.text(`• ${skill}`, 25, yPos);
    yPos += 7;
  });

  // --- Experience ---
  doc.setTextColor(...primaryColor);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('EXPERIENCE', 20, yPos + 10);
  doc.line(20, yPos + 12, 60, yPos + 12);

  yPos += 20;
  doc.setTextColor(...textColor);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Hara XY Innovation Lab Pvt Ltd', 20, yPos);
  
  doc.setTextColor(...lightTextColor);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'oblique');
  doc.text(`${new Date(data.startDate).toLocaleDateString()} - ${new Date(data.endDate).toLocaleDateString()}`, pageWidth - 20, yPos, { align: 'right' });

  yPos += 7;
  doc.setTextColor(...secondaryColor);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text(data.role, 20, yPos);

  yPos += 10;
  doc.setTextColor(...textColor);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  const experienceText = `• Contributed to core innovation projects emphasizing ${data.skills[0] || 'technical excellence'}.
• Collaborated with cross-functional teams to deliver scalable solutions.
• Gained practical experience in industrial workflows and professional standards.
• Participated in regular sprint reviews and technical documentation.`;
  const splitExp = doc.splitTextToSize(experienceText, pageWidth - 40);
  doc.text(splitExp, 20, yPos);

  // --- Certification ---
  yPos += 35;
  doc.setTextColor(...primaryColor);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('CERTIFICATION', 20, yPos);
  doc.line(20, yPos + 2, 50, yPos + 2);

  yPos += 10;
  doc.setTextColor(...textColor);
  doc.setFontSize(10);
  doc.text(`Verified Internship Certificate: ${data.certificateId}`, 20, yPos);
  doc.setTextColor(...secondaryColor);
  doc.text(`Verification URL: https://hara-xy.com/internship-certificates/${data.certificateId}`, 20, yPos + 5);

  // --- Footer ---
  doc.setTextColor(150, 150, 150);
  doc.setFontSize(8);
  doc.text('Generated by Hara-XY Enterprise Management System', pageWidth / 2, 285, { align: 'center' });

  // Save PDF
  doc.save(`${data.name.replace(/\s+/g, '_')}_Resume.pdf`);
};
